export default function getResource(label, vars = []) {
    const resources = {
        updatedLabel: 'MIS À JOUR',
        applyText: 'Appliquer',
        viewPromoCodesText: 'Voir les offres en vedette',
        ccPromoLabel: 'Promo Code',
        promoLabel: 'Code promo',
        gotIt: 'Compris',
        youCanAddPromos: 'Certaines promotions ne s’appliquent pas aux commandes à ramasser. Vous pouvez ajouter des récompenses en magasin, s’il y a lieu.',
        viewFeaturedOffers: 'Voir les offres en vedette'
    };

    return resources[label];
}
